import { createApp } from "vue";
import App from "./App.vue";

function initContactPopup() {
    const root = document.querySelector(".contact-popup");

    if (!root) {
        return;
    }

    createApp(App, {
        apiUrl: root.dataset.apiUrl || "api/contact-popup",
        pageId: root.dataset.pageId || "",
        pageClass: root.dataset.pageClass || "",
    }).mount(root);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactPopup);
} else {
    initContactPopup();
}
